import { gql, useQuery } from '@apollo/client';

export const GET_APPLICATIONS_EUA_SETTING = gql`
  query getEuaCompanySetting($companyId: String!) {
      getEuaCompanySetting(companyId: $companyId) {
      type
      email
      _id
      companyId
      eAUTemplateAcceptedId
      eAUTemplateId
      eAUTemplateRejectedId
      rejectReasons {
        reason
        rejectValue
      }
    }
  }
`;

export const useGetEuaCompanySetting = (companyId?: string) => {
  const { data, loading } = useQuery(GET_APPLICATIONS_EUA_SETTING, {
    variables: { companyId },
    skip: !companyId,
  });

  const euaSetting = data?.getEuaCompanySetting || {};

  return { euaSetting, loading };
};
